import React, { Dispatch, SetStateAction } from 'react';
import { BRAND, isMarketGB } from 'src/constants/main';
import { SummaryPriceDetailsAC } from './AC/SummaryPriceDetails.AC';
import { SummaryPriceDetailsOV } from './OV/SummaryPriceDetails.OV';
import { SummaryPriceDetailsAP } from './AP/SummaryPriceDetails.AP';
import { SummaryPriceDetailsDS } from './DS/SummaryPriceDetails.DS';
import { SummaryPriceDetailsOV as SummaryPriceDetailsOV_GB } from './OV/GB/SummaryPriceDetails.OV';
import { SummaryPriceDetailsStyled } from './SummaryPriceDetailsStyled';
import { SC } from 'src/styles/theme';

export type SummaryPriceDetailsProps = SC & {
    handleFinanceWidgetBtnClick: () => void;
    isMobile?: boolean;
    isBasket?: boolean;
    isDealer?: boolean;
    isOpenPriceDetails?: boolean;
    setIsOpenPriceDetails?: Dispatch<SetStateAction<boolean>>;
};

const SummaryPriceDetails = (props: SummaryPriceDetailsProps) => {
    if (BRAND === 'AC') return <SummaryPriceDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <SummaryPriceDetailsOV_GB {...props} /> : <SummaryPriceDetailsOV {...props} />;
    if (BRAND === 'AP') return <SummaryPriceDetailsAP {...props} />;
    if (BRAND === 'DS') return <SummaryPriceDetailsDS {...props} />;
    return <SummaryPriceDetailsStyled {...props} />;
};

export default SummaryPriceDetails;
